import { createVNode as e, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileUnknowTwotoneStandard.js";
import d from "../components/PfIcon.js";
const o = (t, n) => {
  const r = {
    ...t,
    ...n.attrs
  };
  return e(d, a(r, {
    icon: i
  }), null);
};
o.displayName = "FileUnknowTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
